module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_7_4.388f9e2c.png";